import React from 'react';
import { Stack, Text } from '@moda/om';
import { RestAddress, useAddressesQuery } from '../../../hooks/useAddress';
import { ShippingAddressPreview } from '../../ShippingAddress';
import './AppleShippingAddressPreview.scss';
import { throwQueryError } from '../../../lib/apollo/throwQueryError';

type Props = {
  address: RestAddress;
  addressId?: number | null;
};

export const AppleShippingAddressPreview: React.FC<Props> = ({ address, addressId }) => {
  const { addresses, error: addressesError } = useAddressesQuery({ skip: address != null });

  const selectedAddress = address || addresses.find(address => address.id === String(addressId));

  if (addressesError) throwQueryError(addressesError);

  if (!selectedAddress) return null;

  return (
    <Stack space={0} className="AppleShippingAddressPreview">
      <Stack space={1} direction="horizontal" alignItems="center">
        <img className="AppleShippingAddressPreview__logo" alt="Apple" src="/apple_pay.svg" />
        <Text treatment="eyebrow">Shipping Address</Text>
      </Stack>
      <ShippingAddressPreview attributes={selectedAddress.attributes} />
    </Stack>
  );
};
